import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { App as AntdApp } from 'antd';
import { store, persistor } from 'src/store';

import { IntlWrapper } from '@skynet/intl-feature';
import { ThemeWrapper } from '@skynet/theme-feature';
import Router from 'src/router';
import { AppErrorBoundary } from 'src/error-boundary/AppErrorBoundary';

export function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <IntlWrapper>
          <ThemeWrapper>
            <AppErrorBoundary>
              <AntdApp>
                <Router />
              </AntdApp>
            </AppErrorBoundary>
          </ThemeWrapper>
        </IntlWrapper>
      </PersistGate>
    </Provider>
  );
}
